// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "category_title-2YNmJ";
var _3 = "price_label-Z9agl";
var _4 = "perFlight-3vppI";
export { _1 as "__esModule", _2 as "category_title", _3 as "price_label", _4 as "perFlight" }
export default { "__esModule": _1, "category_title": _2, "price_label": _3, "perFlight": _4 }
